import React from "react";
import { Box, Typography } from "@mui/material";

const SDGS_GOAL_LABELS = {
  "1": "1. 貧困をなくそう",
  "2": "2. 飢餓をゼロに",
  "3": "3. すべての人に健康と福祉を",
  "4": "4. 質の高い教育をみんなに",
  "5": "5. ジェンダー平等を実現しよう",
  "6": "6. 安全な水とトイレを世界中に",
  "7": "7. エネルギーをみんなに そしてクリーンに",
  "8": "8. 働きがいも経済成長も",
  "9": "9. 産業と技術革新の基盤をつくろう",
  "10": "10. 人や国の不平等をなくそう",
  "11": "11. 住み続けられるまちづくりを",
  "12": "12. つくる責任 つかう責任",
  "13": "13. 気候変動に具体的な対策を",
  "14": "14. 海の豊かさを守ろう",
  "15": "15. 陸の豊かさも守ろう",
  "16": "16. 平和と公正をすべての人に",
  "17": "17. パートナーシップで目標を達成しよう",
};

const titleSx = { mt: 3, mb: 1, fontWeight: 700 };
const labelSx = { width: "200px", fontWeight: 700, flexShrink: 0 };
const valueSx = {
  flex: 1,
  borderBottom: "1px solid #999",
  minHeight: "20px",
  whiteSpace: "pre-wrap",
  wordBreak: "break-word",
};
const rowSx = { display: "flex", gap: 2, mb: 1.2, alignItems: "flex-start" };

const valueOrEmpty = (value) => value ?? "";
const boolText = (value) => (value === true ? "使用する" : value === false ? "使用しない" : "");

const Comp19PDF = ({ formData }) => {
  if (!formData) return null;

  const submission = formData.r19?.[0] ?? formData;
  const sdgsGoals = Array.isArray(submission.sdgs_goals)
    ? submission.sdgs_goals.map((goal) => SDGS_GOAL_LABELS[String(goal)] ?? String(goal))
    : [];

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h6" sx={{ mb: 3 }}>
        出展内容確認
      </Typography>

      <Box sx={rowSx}>
        <Typography sx={labelSx}>小間番号</Typography>
        <Box sx={valueSx}>{valueOrEmpty(submission.booth_number ?? formData.booth_number)}</Box>
      </Box>
      <Box sx={rowSx}>
        <Typography sx={labelSx}>出展者名</Typography>
        <Box sx={valueSx}>{valueOrEmpty(submission.company_name ?? formData.company_name)}</Box>
      </Box>

      <Typography sx={titleSx}>担当者情報</Typography>
      <Box sx={rowSx}>
        <Typography sx={labelSx}>氏名</Typography>
        <Box sx={valueSx}>{valueOrEmpty(submission.user_19_name)}</Box>
      </Box>
      <Box sx={rowSx}>
        <Typography sx={labelSx}>部署</Typography>
        <Box sx={valueSx}>{valueOrEmpty(submission.user_19_department)}</Box>
      </Box>
      <Box sx={rowSx}>
        <Typography sx={labelSx}>会社電話番号</Typography>
        <Box sx={valueSx}>{valueOrEmpty(submission.user_19_phone)}</Box>
      </Box>
      <Box sx={rowSx}>
        <Typography sx={labelSx}>携帯電話番号</Typography>
        <Box sx={valueSx}>{valueOrEmpty(submission.user_19_tel)}</Box>
      </Box>

      <Typography sx={titleSx}>出展内容</Typography>
      <Box sx={rowSx}>
        <Typography sx={labelSx}>出展名</Typography>
        <Box sx={valueSx}>{valueOrEmpty(submission.com_name)}</Box>
      </Box>
      <Box sx={rowSx}>
        <Typography sx={labelSx}>出展内容</Typography>
        <Box sx={valueSx}>{valueOrEmpty(submission.exhibit_ways)}</Box>
      </Box>
      <Box sx={rowSx}>
        <Typography sx={labelSx}>推進するSDGsゴール</Typography>
        <Box sx={valueSx}>{sdgsGoals.join("\n")}</Box>
      </Box>

      <Typography sx={titleSx}>基礎小間付帯設備 利用確認</Typography>
      <Box sx={rowSx}>
        <Typography sx={labelSx}>長机</Typography>
        <Box sx={valueSx}>{boolText(submission.basic_structure)}</Box>
      </Box>
      <Box sx={rowSx}>
        <Typography sx={labelSx}>パイプ椅子</Typography>
        <Box sx={valueSx}>{boolText(submission.basic_chair)}</Box>
      </Box>
      <Box sx={rowSx}>
        <Typography sx={labelSx}>側面パネル</Typography>
        <Box sx={valueSx}>{boolText(submission.side_panel)}</Box>
      </Box>

      <Typography sx={titleSx}>備考</Typography>
      <Box sx={valueSx}>{valueOrEmpty(submission.alfa_text)}</Box>
    </Box>
  );
};

export default Comp19PDF;